module.exports = __webpack_public_path__ + "494cd07c/img/boston-lights.a623432f.png";